import React from 'react';
var Logo = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-allhomes-agent-recommendations/static/rma-logo_072ab9ea.svg";
import * as styles from './footer-old.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Footer = () => ___EmotionJSX("div", null, ___EmotionJSX("span", {
  css: styles.text
}, "Recommendations provided by"), ___EmotionJSX("span", null, ___EmotionJSX("img", {
  alt: "",
  src: Logo
})));
export default Footer;